export default {"src":"/_next/static/media/minus.3d8665e3.svg","height":25,"width":25};